import { render, staticRenderFns } from "./StockDetailsTemplate.vue?vue&type=template&id=573bc58a&scoped=true&"
import script from "./StockDetailsTemplate.vue?vue&type=script&lang=js&"
export * from "./StockDetailsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StockDetailsTemplate.vue?vue&type=style&index=0&id=573bc58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573bc58a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
